module.exports = __webpack_public_path__ + "img/car1.698ef1f2.png";